import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Pages } from '@enums';
import { ActivatedRoute, Params } from '@angular/router';
import { SetCurrentAdviceDayIdAction, SetCurrentAdvicesPageAction } from '../../store/actions';
import { AppState } from '@appStates';
import { select, Store } from '@ngrx/store';
import { SeoService } from '@core/services';
import { selectCurrentAdviceDay } from 'src/app/store/selectors/start.page.selectors';
import { filter, takeUntil } from 'rxjs/operators';
import { ISingleAdviceDay } from '@interfaces';
import { Subject } from 'rxjs';
import { AdvicesApiService } from '../../core/services/api.services/advices-api.service';

@Component({
  selector: 'bz-tip-of-the-day',
  templateUrl: './tip-of-the-day.component.html',
  styleUrls: ['./tip-of-the-day.component.sass']
})
export class TipOfTheDayComponent implements OnInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef }) public container: ViewContainerRef;

  public view: string;
  public firstLoad = true;

  private destroyer$: Subject<void> = new Subject();

  constructor(
    private readonly routed: ActivatedRoute,
    private readonly advicesApiService: AdvicesApiService,
    private readonly seo: SeoService,
    private readonly store: Store<AppState>
  ) {
    this.seo.getTegRobots(Pages.tips);
    this.seo.updateLinkHreflang();
  }

  ngOnInit(): void {
    this.store.pipe(
      select(selectCurrentAdviceDay),
      filter(value => !!value),
      takeUntil(this.destroyer$)
    ).subscribe((data: ISingleAdviceDay) => {
      this.seo.setStaticTitleWithOutTranslate(data.title);
      this.seo.setStaticDescriptionWithOutTranslate(`${data.title} - ${data.listName}`);
    });
    this.routed.params
      .pipe(takeUntil(this.destroyer$))
      .subscribe((params: Params) => {
        this.view = params.name;
        if (this.view) {
          this.store.dispatch(SetCurrentAdviceDayIdAction({ id: this.view }));
          this.advicesApiService.getSingleAdviceDayTip(this.view);
        } else {
          // установить текущую страницу - 1
          this.store.dispatch(SetCurrentAdvicesPageAction({ page: 1 }));
          this.advicesApiService.getAllAdvicesWithPagesNum(1);
        }
      });
    this.firstLoad = false;
  }

  ngOnDestroy(): void {
    this.destroyer$.next(null);
    this.destroyer$.complete();
  }

}
